import {
  CREATE_ENTITY_APPLICATION_ONLY_URL,
} from '@/utils/system_constants/constant.js';
import {
  getXVerdictFullConfigByEntityType,
} from '@/services/xverdict_entity_config_service';
import {
  mapRiskBindingsToAssessments,
} from '@/services/xverdict_config_mapper';
import {
  fetch_submitted_risk_assessment_answers,
} from '@/services/risk_service';

const DEFAULT_NEW_CASE_FORM = {
  entity_type_id: '',
  requester: '',
  user_email: '',
  description: '',
  value: '',
  source_channel: 'Email'
};

function create_company_cases_state() {
  return {
    active_filter: 'all',
    show_new_case_modal: false,
    show_route_case_modal: false,
    route_case: null,
    route_priority: '',
    route_destination: '',
    route_group: '',
    workflow_status_filter_options: [],
    route_status_options: [],
    route_role_options: [],
    route_role_group_options: [],
    route_user_options: [],
    case_owner_directory_by_id: new Map(),
    route_selected_user_ids: [],
    route_select_all_users: false,
    route_error: '',
    route_loading: false,
    submitting_route_case: false,
    new_case_form: { ...DEFAULT_NEW_CASE_FORM },
    cases: [],
    case_types: [],
    loading_cases: false,
    cases_error: '',
    new_case_error: '',
    current_page: 1,
    page_size: 10,
    submitting_new_case: false,
    onboarding_preview: null,
    onboarding_preview_loading: false,
    onboarding_preview_error: '',
    onboarding_execution: null,
    onboarding_status: null,
    created_case: null
  };
}

export {
  CREATE_ENTITY_APPLICATION_ONLY_URL,
  DEFAULT_NEW_CASE_FORM,
  create_company_cases_state,
  fetch_submitted_risk_assessment_answers,
  getXVerdictFullConfigByEntityType,
  mapRiskBindingsToAssessments,
};
export {
  first_present,
  get_entity_type_name,
  is_open_case_status,
  normalize_key,
  normalize_text,
  read_session_current_role,
  read_session_current_user_id,
  read_session_project_id,
  to_number,
} from './company_cases_common';
export {
  axios,
  clear_entity_profile_list_cache,
  fetch_current_user_case_scope,
  fetch_entity_profiles,
  fetch_entity_profiles as fetch_cases,
  is_real_case_record,
  fetch_scoped_entity_types,
  fetch_entity_types,
  get_request_config,
  hydrate_case_display_title,
  map_backend_case,
} from './company_cases_response_helpers';
export { risk_details } from './company_cases_risk_helpers';
